<template>
  <div class="page-login">
    <img
      src="../assets/images/login/logo.png"
      class="login_img"
    />
    <div class="login_outer">
      <div class="login_inner">
        <el-form
          ref="ruleForm2"
          :model="ruleForm2"
          label-width="80px"
        >
          <h3 class="title">登录账户</h3>
          <div class="login_user">
            <div class="user_img">
              <img src="../assets/images/login/user.png" />
            </div>
            <el-input
              maxlength="50"
              type="text"
              v-model="ruleForm2.account"
              @keyup.native="filterInput(ruleForm2, 'account')"
              auto-complete="off"
              placeholder="请输入账号"
            ></el-input>
          </div>
          <div
            class="login_password"
            v-if="isPasswordLoginFlag"
          >
            <div class="password_img">
              <img src="../assets/images/login/password.png" />
            </div>
            <el-input
              maxlength="20"
              type="password"
              v-model="ruleForm2.checkPass"
              @keyup.native="filterInput(ruleForm2, 'checkPass')"
              auto-complete="off"
              placeholder="请输入密码"
            ></el-input>
          </div>
          <div
            style="text-align: center"
            v-if="!isPasswordLoginFlag"
          >
            <img
              src="../assets/images/login/zhiwen.png"
              width="46px"
              height="46px"
            />
          </div>
          <span id="yzMsg">{{yzMsg}}</span>
          <br />
          <div class="login-button">
            <el-button
              type="primary"
              @click.native.prevent="handleLoginClick"
              :loading="loging"
              class="h-center"
            >登 录</el-button>
            <a
              class="link"
              @click="handleRegistrationClick"
            >终端注册</a>
          </div>
        </el-form>
      </div>
    </div>
    <yh-dialog
      title="终端注册"
      :visible.sync="loanDialog"
      @close="handleCloseClick"
    >
      <el-form>
        <el-form-item
          label="机构代码"
          v-show="transShow"
        >
          <el-input
            readonly
            :value="transOrgCode"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="机构名称"
          v-show="transShow"
        >
          <el-input :value="transOrgName"></el-input>
        </el-form-item>
        <el-form-item
          label="负责人"
          v-show="transShow"
        >
          <el-input
            :value="userName"
            v-show="transShow"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-show="transShow"
          label="贵宾室"
        >
          <el-input
            v-show="transShow"
            :value="vipAddr"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备ID">
          <el-input v-model="transNo"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="handleCloseClick">关闭</el-button>
        <yh-button
          type="primary"
          @click="handleSubmitClick"
        >提交</yh-button>
      </span>
    </yh-dialog>
  </div>
</template>

<script>
import md5 from 'md5';

export default {
  data() {
    return {
      logDeviceId: '',
      macId: '',
      ip: '',
      transOrgCode: '',
      transOrgName: '',
      userName: '',
      roleInfo: '',
      vipAddr: '',
      isFMSSClient: false,
      transShow: false,
      transNo: '', // 设备号
      loanDialog: false, // 注册终端
      isPasswordLoginFlag: true, // 默认密码登录true    指纹登录false
      isPasswordCount: 0,
      fingerPrint: '', // 扫描指纹返回的结果
      companyType: '', // 指纹仪类型
      tableData: {
        userName: '',
        workNo: '',
        phone: '',
        orgnName: '',
        orgnCode: '',
        gender: '',
        roleName: '',
      },
      yzMsg: '',
      credentialsDialog: false,
      loging: false,
      ruleForm2: {
        // 8511299
        account: '',
        checkPass: '',
      },
      rules2: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        checkPass: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      checked: true,
      userOrgnCode: '',
    };
  },
  created() {
    // 登录添加键盘事件,注意,不能直接在焦点事件上添加回车
    document.addEventListener('keydown', this.handleKeydown);
  },
  mounted() {
    // 判断是否是理财终端
    const RecCode = $.busitrans.getParamValue('isClient');
    if (RecCode !== '-9999') {
      // 说明是理财终端
      this.isFMSSClient = true;
      const logDevId = $.busitrans.getDeviceNo(); // 交易设备标识号
      // if (!logDevId) {
      // 只有理财经理登录才需要联通外屏
      //   this.$message.warning('无法获取外屏设备ID和IP');
      // }
      this.transNo = logDevId;
    }
  },
  destroyed() {
    // 删除键盘事件
    document.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    filterInput(data, key) {
      // eslint-disable-next-line no-param-reassign
      data[key] = data[key].replace(/[^\da-zA-Z]/g, '');
    },
    handleKeydown(e) {
      const key = e.keyCode;
      if (key === 13 && this.$route.path === '/login') {
        this.handleLoginClick();
      }
    },
    handleRegistrationClick() {
      const logDevId = $.busitrans.getDeviceNo(); // 交易设备标识号
      if (!logDevId) {
        this.$message.warning('无法获取外屏设备ID和IP');
      }
      this.transNo = logDevId;
      this.loanDialog = true;
    },
    // 查询设备号是否存在
    checkTransNo() {
      if (!this.transNo) {
        this.$message.warning('请输入设备ID');
        return false;
      }
      if (this.transNo.length > 50) {
        this.$message.warning('设备ID不能超过50个字符');
        return false;
      }
      return true;
    },
    handleSubmitClick() {
      if (!this.checkTransNo()) {
        return false;
      }
      const parames = {
        data: {
          logDeviceId: this.transNo,
        },
      };
      return this.$_post(this.$API.systemTerminal, parames).then((res) => {
        if (res.errorCode === this.$CODE.success) {
          this.transShow = true;
          this.loanDialog = false;
          this.transOrgCode = res.data.info?.orgnCode;
          this.transOrgName = res.data.info?.orgnName;
          this.userName = res.data.info?.userName;
          this.vipAddr = res.data.info?.vipAddr;
          // 写入c#
          try {
            const result = $.busitrans.setDeviceNo(this.transNo).split(',')[0];
            if (result === '5') {
              this.$message.warning('终端注册失败，请检查理财机是否开机');
            } else {
              this.$message.success('终端注册成功!');
            }
          } catch (e) {
            this.$message.warning('终端注册失败，请检查理财机是否开机');
          }
          this.transShow = false;
        } else {
          this.$message.warning(res.errorMsg);
          this.transShow = false;
        }
      });
    },
    // 关闭终端注册的窗口
    handleCloseClick() {
      this.transShow = false;
      this.loanDialog = false;
    },
    getUserInfo(userCode) {
      const parames = {
        data: {
          userCode,
        },
      };
      let logDeviceId = ''; // 设备号
      let macId = ''; // mac
      let ip = ''; // ip
      let flag = '0'; // 0代表是网页，1代表终端
      return this.$_post(this.$API.systemRoleInfo, parames).then((res) => {
        if (!res.data.userInfo) {
          this.loging = false;
          this.yzMsg = '帐号或密码错误，请重试';
          return;
        }
        const isManager = res.data.userInfo.isManager === '1';
        this.roleInfo = res.data.roleInfo;
        this.roleInfo.isManager = isManager;
        if (!isManager) {
          this.userLoginFun('', '', ip, '1');
        } else {
          flag = '1';
          logDeviceId = $.busitrans.getDeviceNo(); // 交易设备标识号
          console.log(`设备号为：${logDeviceId}是理财经理`);
          if (!logDeviceId) {
            this.$message.warning('无法获取外屏设备ID和IP');
            this.loging = false;
            return;
          }
          // MAC地址IP地址
          const macIp = $.busitrans.getMacIp(); // MAC地址IP地址
          if (!macIp) {
            this.$message.warning('无法获取外屏设备ID和IP');
            this.loging = false;
            return;
          }
          const arr = macIp.split('#=#');
          if (arr.length > 1) {
            [, macId] = arr;
          }
          if (arr.length > 2) {
            [, , ip] = arr;
          }
          this.logDeviceId = logDeviceId;
          this.macId = macId;
          this.ip = ip;
          this.login(logDeviceId, macId, ip, flag);
        }
      });
    },
    handleLoginClick() {
      this.loging = true;
      if (!this.ruleForm2.account || this.ruleForm2.account.trim() === '') {
        this.yzMsg = '请输入账号';
        this.loging = false;
      } else if (
        this.isPasswordLoginFlag
        && (!this.ruleForm2.checkPass || this.ruleForm2.checkPass.trim() === '')
      ) {
        this.yzMsg = '请输入密码';
        this.loging = false;
      } else {
        const flag = '0'; // 0代表是网页，1代表终端
        // 终端设备号校验
        const RecCode = $.busitrans.getParamValue('isClient');
        this.loginNo = this.ruleForm2.account;
        console.log(this.loginNo);
        if (RecCode !== '-9999') {
          // 发送请求
          this.getUserInfo(this.ruleForm2.account);
        } else {
          this.login(this.logDeviceId, this.macId, this.ip, flag);
        }
      }
    },
    getDoubleRecording() {
      const parames = {
        data: {
          logDeviceId: this.transNo,
        },
      };
      return this.$_post(this.$API.getDoubleParm, parames).then((res) => {
        $.busitrans.writeVideoUploadFile(res.data?.info);
      });
    },

    login(logDeviceId, macId, ip, flag) {
      // 密码登录
      return this.userLoginFun(logDeviceId, macId, ip, flag);
    },
    // 根据是否密码登录，配置登录参数
    getLoginParam(logDeviceId, macId, ip, flag) {
      return {
        userCode: this.ruleForm2.account.trim(),
        passWord: md5(this.ruleForm2.checkPass.trim()),
        isPasswordLoginFlag: this.isPasswordLoginFlag,
        logDeviceId,
        macId,
        ip,
        flag,
      };
    },
    // async
    userLoginFun(logDeviceId, macId, ip, flag) {
      this.loging = true;
      const parames = {
        data: this.getLoginParam(logDeviceId, macId, ip, flag),
      };
      // await
      return this.$_post(this.$API.login, parames)
        .then((res) => {
          this.loging = false;
          const yzMsg = document.getElementById('yzMsg');
          this.loging = false;
          const needAlert = [
            this.$CODE.noAccount,
            this.$CODE.freezeAccount,
            this.$CODE.invalidID,
            this.$CODE.invalidIP,
            this.$CODE.invalidPerson,
          ];
          if (needAlert.includes(res.errorCode)) {
            this.yzMsg = res.errorMsg;
          } else if (res.errorCode !== this.$CODE.success) {
            this.$message.warning(res.errorMsg);
          } else {
            yzMsg.setAttribute('style', 'display: none');
            // this.getDoubleRecording();
            const sessData = {
              // 用户ID
              userId: res.data.info.user?.id,
              // 角色ID
              roleId: res.data.info.role?.id,
              // 用户账户
              userCode: res.data.info.user?.userCode,
              // 机构码
              orgnCode: res.data.info.user?.orgnCode,
              // 父级机构码
              parentOrgnCode: res.data.organization?.parentOrgnCode,
              // 机构ID
              orgnId: res.data.info.user?.orgnId,
              // 用户名
              userName: res.data.info.user?.userName,
              // 工号
              workNo: res.data.info.user?.workNo,
              // 机构名
              orgnName: res.data.info.organization?.orgnName,
              // 机构等级
              orgnLevel: res.data.info.organization?.orgnLevel,
              // 三级行社
              orgnCodeLv3: res.data.orgnCodeLv3,
              // 角色名
              roleName: res.data.info.role?.roleName,
              // 数据权限
              dataAuth: res.data.info.role?.dataAuth,
              phone: res.data.info.user?.phone,
              // 性别
              gender: res.data.info.user?.gender,
              orgnInheritSign: res.data.info.organization?.orgnInheritSign,
              isManager: res.data.info.role.isManager,
            };
            this.$store.commit('setToken', res.data.info.token);
            this.$store.commit('setUserId', res.data.info.userId);
            this.$store.commit('setMenuList', res.data.info.list);
            this.$store.commit('setFeatureList', res.data.info.menuList);
            sessionStorage.setItem('sessionData', JSON.stringify(sessData));
            try {
              // 给C#是否登录的状态
              if (sessData.isManager === '1') {
                $.busitrans.sendKeyValue('isLogin', '1');
                // c#使用
                $.busitrans.sendKeyValue('islogin', '1');
                $.busitrans.sendKeyValue('managerInfo', JSON.stringify(sessData));
                $.busitrans.sendKeyValue('managerno', sessData.workNo);
                $.busitrans.setParamValue('workno', this.loginNo);
                $.busitrans.sendKeyValue('userId', sessData.userId);
                $.busitrans.sendKeyValue('token', res.data.info.token);
                console.log('token=====', res.data.info.token);
                console.log('userId=====', sessData.userId);
              } else {
                $.busitrans.sendKeyValue('isLogin', '2');
                $.busitrans.sendKeyValue('islogin', '2');
              }
            } catch (e) {
              this.$_throw(e);
            }

            const { menuList } = this.$store.getters;
            if (!menuList || menuList.length === 0) {
              // 无权限用户
              this.$store.commit('clearTab');
              this.$router.push({
                path: '/no-access',
              });
            } else {
              this.$router.push({ path: '/' });
            }
          }
        })
        .catch(() => {
          this.loging = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-top: 50px !important;
}
#yzMsg {
  margin-top: -2px;
  text-align: center;
  vertical-align: center;
  color: #cf4061;
  margin-left: 73px;
}
.link {
  float: right;
  font-size: 16px;
  margin-right: 20%;
  margin-top: 4%;
  text-decoration: underline;
}
.link:hover {
  cursor: pointer;
}
.page-login {
  background-image: url(../assets/images/login/bg.png);
  width: 100%;
  height: 100%;
}
.login_img {
  margin-left: 40%;
  margin-top: 5%;
  margin-bottom: 20px;
}
.login_outer {
  position: relative;
  margin: auto;
  width: 550px;
  height: 386px;
  background-color: rgb(180, 200, 232);
}
.login_inner {
  position: relative;
  margin-left: 20px;
  top: 18px;
  width: 510px;
  height: 350px;
  background-color: rgb(225, 233, 246);
}
.login_user,
.login_password {
  margin-left: 73px;
}
.login_user .el-input,
.login_password .el-input {
  height: 50px;
  width: 342px;
}
.login_user {
  margin-bottom: 15px;
}
.user_img,
.password_img {
  float: left;
  height: 40px;
  width: 40px;
  background: #c8c8c8;
}
.user_img img,
.password_img img {
  margin: 6.5px 8.5px;
}
.login-button {
  margin-top: 30px;
  position: relative;
}
.login-button .el-button {
  height: 42px;
  width: 100px;
  color: #ffffff;
  font-size: 15px;
}
.login-button a {
  color: #ea8b15;
  font-size: 14px;
}
.remember {
  margin: 0 45px;
}
.title {
  position: relative;
  padding-top: 44px;
  padding-left: 202px;
  margin-bottom: 22px;
  color: #434343;
  font-size: 24px;
}
</style>
